var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipResultDotWon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.375,
    height: 12.381,
    viewBox: "0 0 12.375 12.381",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.188 12.38c3.398 0 6.187-2.794 6.187-6.192C12.375 2.795 9.58 0 6.187 0 2.79 0 0 2.795 0 6.188c0 3.398 2.795 6.193 6.188 6.193zM5.543 9.13c-.264 0-.469-.117-.656-.346L3.51 7.143a.716.716 0 0 1-.188-.48c0-.364.293-.651.65-.651.212 0 .376.082.534.27l1.02 1.259L7.81 3.908c.152-.246.345-.369.574-.369.351 0 .674.258.674.621a.823.823 0 0 1-.164.457l-2.72 4.16a.764.764 0 0 1-.632.352z",
    fill: "#6633ff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipResultDotWon);
export default __webpack_public_path__ + "static/media/tip-result-dot-won.b179eb8fe2a7941d4c8869c99dadaaaa.svg";
export { ForwardRef as ReactComponent };